import Vue from 'vue'
import App from './App.vue'
import router from '@router'
import { expandAxios } from '@api'
import utils from '@utils'
import ElementUI from 'element-ui'
import store from '@store'
import storage from '@storage'
import staticData from '@static'
// 引入全局样式  以originp- 为前缀
import '@assets/styles/app.scss'
import '@assets/styles/global.scss'
// 全局修改elementUI的样式
import '@assets/styles/element-variables.scss'
// 引入新的图标库
import '@fortawesome/fontawesome-free/css/all.css';

Vue.prototype.$utils = utils
Vue.prototype.$storage = storage
Vue.prototype.$static = staticData

expandAxios({ Vue })

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
